const mediaConstraints = { audio: true, video: false };

let AudioContext, context, processor, globalStream, input;
let currentConfig = null;
const ROLLOVER_MS = 50 * 60 * 1000;    //Rollover after 50 minutes to accommodate GCP timeout
const COUNTDOWN_SECONDS = 5;

let rolloverTimeout = null;
let countdownInterval = null;
let nextRestartAt = null;

function scheduleRollover(socket, setListeningText) {
  if (rolloverTimeout) {
    clearTimeout(rolloverTimeout);
  }

  nextRestartAt = Date.now() + ROLLOVER_MS;

  rolloverTimeout = setTimeout(() => {
    console.log("[AudioStreamer] proactive session rollover");

    setListeningText?.("Restarting...");

    socket.emit("restartClient", {
      ...currentConfig,
      existingTranscript: window.currentTranscript || ""
    });

    // Schedule the next 50-minute rollover
    scheduleRollover(socket, setListeningText);
  }, ROLLOVER_MS);
}

let AudioStreamer = {
  startRecording(socket, config, setListeningText) {

    AudioContext = window.AudioContext || window.webkitAudioContext;
    context = new AudioContext();
    processor = context.createScriptProcessor(4096, 1, 1);
    processor.connect(context.destination);
    context.resume();

    navigator.mediaDevices.getUserMedia(mediaConstraints)
      .then((stream) => {
        //console.log("[AudioStreamer] getUserMedia success");
        globalStream = stream;
        input = context.createMediaStreamSource(stream);
        input.connect(processor);

        socket.emit("startClient", config);
        currentConfig = config;
        setListeningText?.("Listening...");

        scheduleRollover(socket, setListeningText);

        countdownInterval = setInterval(() => {
          if (!nextRestartAt) return;

          const secondsLeft = Math.ceil((nextRestartAt - Date.now()) / 1000);

          if (secondsLeft <= COUNTDOWN_SECONDS && secondsLeft > 0) {
            setListeningText?.(`Restarting in ${secondsLeft}`);
          } else if (secondsLeft <= 0) {
            setListeningText?.("Restarting...");
          } else {
            setListeningText?.("Listening...");
          }
        }, 500);

        processor.onaudioprocess = (e) => {
          const left = e.inputBuffer.getChannelData(0);
          //console.log("[AudioStreamer] onaudioprocess frame length:", left.length);
          const left16 = convertFloat32ToInt16(left);
          //console.log("[AudioStreamer] Emitting audioData of bytes:", left16.byteLength);
          // Verify the type being sent is a raw ArrayBuffer
          if (left16 instanceof ArrayBuffer) {
            socket.emit("audioData", left16);
          } else {
            console.error("Audio data is not an ArrayBuffer, this will fail binary transmission!");
          }
        };
      })
      .catch((err) => {
        console.error("[AudioStreamer] getUserMedia error:", err);
      });

    socket.off("stopClient");

    socket.on("stopClient", () => {
      console.log("[AudioStreamer] stopClient received");
      closeAll(socket);
    });
  },

  stopRecording(socket) {
    socket.emit("stopClient");
    closeAll(socket);
  },
};

export { AudioStreamer };

function convertFloat32ToInt16(buffer) {
  const l = buffer.length;
  const buf = new Int16Array(l);
  for (let i = 0; i < l; i++) {
    let s = Math.max(-1, Math.min(1, buffer[i]));
    buf[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
  }
  return buf.buffer;
}

function closeAll(socket) {
  console.log("[AudioStreamer] closeAll called");
  if (globalStream) {
    globalStream.getTracks().forEach((t) => {
      t.stop();
    });
  }
  if (input && processor) {
    try {
      input.disconnect(processor);
    } catch (err) {
      console.warn("[AudioStreamer] input disconnect failed:", err);
    }
    processor.disconnect(context.destination);
  }
  if (context) {
    context.close().then(() => {
      console.log("[AudioStreamer] AudioContext closed");
      input = processor = context = AudioContext = null;
    });
  }

  if (rolloverTimeout) {
    clearTimeout(rolloverTimeout);
    rolloverTimeout = null;
  }

  if (countdownInterval) {
    clearInterval(countdownInterval);
    countdownInterval = null;
  }

  nextRestartAt = null;
  currentConfig = null;
}
